export default __webpack_public_path__ + "static/media/logout-icon.03dbd8b6.svg";